import { render, staticRenderFns } from "./ClientMainInfo.component.vue?vue&type=template&id=70f30196&scoped=true&"
import script from "./ClientMainInfo.component.vue?vue&type=script&lang=js&"
export * from "./ClientMainInfo.component.vue?vue&type=script&lang=js&"
import style0 from "./ClientMainInfo.component.vue?vue&type=style&index=0&id=70f30196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f30196",
  null
  
)

export default component.exports